module.exports = __webpack_public_path__ + "static/feature-2-cc0bbc0881e9fd50037839b8b28f8a14.png";